// extracted by mini-css-extract-plugin
export default {"coffee":"food_coffee__lTixN"};